// extracted by mini-css-extract-plugin
export default {"game":"Game_game__a7w2d"};